"use client";

import { Button } from "@/components/ui/button";
import { Checkbox } from "@/components/ui/checkbox";
import { ColumnDef } from "@tanstack/react-table";

import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { Badge } from "@/components/ui/badge";
import { DataPendaftaran } from "@/types";
import { ArrowUpDown, ChevronDown, ChevronRight } from "lucide-react";
import Actions from "./Actions";

export const columns: ColumnDef<DataPendaftaran>[] = [
  {
    id: "expander",
    header: "",
    cell: ({ row }) => {
      return (
        <Button
          variant="ghost"
          size="sm"
          onClick={() => row.toggleExpanded()}
          className="p-0 h-8 w-8"
        >
          {row.getIsExpanded() ? (
            <ChevronDown className="h-4 w-4" />
          ) : (
            <ChevronRight className="h-4 w-4" />
          )}
        </Button>
      );
    },
  },
  {
    id: "select",
    header: ({ table }) => (
      <Checkbox
        checked={
          table.getIsAllPageRowsSelected() ||
          (table.getIsSomePageRowsSelected() && "indeterminate")
        }
        onCheckedChange={(value) => table.toggleAllPageRowsSelected(!!value)}
        aria-label="Select all"
      />
    ),
    cell: ({ row }) => (
      <Checkbox
        checked={row.getIsSelected()}
        onCheckedChange={(value) => row.toggleSelected(!!value)}
        aria-label="Select row"
      />
    ),
    enableSorting: false,
    enableHiding: false,
  },
  {
    id: "action",
    cell: ({ row }) => {
      return <Actions row={row.original} />;
    },
  },
  {
    accessorKey: "data_siswa.path_foto",
    header: () => "Foto",
    cell: ({ row }) => {
      const dataSiswa = row.original.data_siswa;
      const pathFoto = dataSiswa?.path_foto || "";
      const namaLengkap = dataSiswa?.nama_lengkap || "User";

      const inisial = namaLengkap
        .split(" ")
        .map((n) => n[0])
        .join("")
        .toUpperCase()
        .substring(0, 2);

      return (
        <div className="flex items-center justify-center">
          <Avatar className="h-12 w-12 border">
            <AvatarImage
              src={pathFoto}
              alt={namaLengkap}
              className="object-cover"
            />
            <AvatarFallback className="bg-muted text-xs font-medium">
              {inisial}
            </AvatarFallback>
          </Avatar>
        </div>
      );
    },
  },
  //   {
  //     accessorKey: "Whatsapp",
  //     header: () => {
  //       return (
  //         <Button variant="ghost">
  //           What'sApp
  //           <ArrowUpDown className="w-4 h-4 ml-2" />
  //         </Button>
  //       );
  //     },
  //     cell: ({ row }) => {
  //       if (row.original.periode?.jalur_jenis?.nama_jalur_jenis_slug != "cbt")
  //         return <div></div>;

  //       return (
  //         <div className="flex justify-center items-center">
  //           <Button
  //             variant={"outline"}
  //             size={"icon"}
  //             onClick={() => {
  //               const rawPhone = row.original?.data_siswa?.handphone || "";
  //               const phone = rawPhone.startsWith("0")
  //                 ? "62" + rawPhone.slice(1)
  //                 : rawPhone;

  //               const message =
  //                 encodeURIComponent(`Pesan ini dikirim melalui sistem, apabila ada pertanyaan silahkan hubungi kontak kami.

  // 📢 [PENGUMUMAN PENTING]
  // Yth. Calon Mahasiswa Jalur Mandiri Undiksha,

  // Kami informasikan bahwa batas akhir pendaftaran SMBJM CBT Jalur Mandiri Universitas Pendidikan Ganesha (Undiksha) adalah besok, 6 Juni 2025.

  // Bagi peserta yang belum menyelesaikan proses pendaftaran (unggah dokumen, pembayaran biaya pendaftaran, atau finalisasi data), diharapkan untuk menyelesaikan seluruh tahapan tersebut paling lambat tanggal 6 Juni 2025.

  // Apabila terdapat kendala teknis atau hambatan lainnya, silakan menginformasikannya melalui room chat ini, agar dapat segera ditindaklanjuti oleh tim kami.

  // Jangan lewatkan kesempatan untuk bergabung menjadi bagian dari Undiksha 💙
  // Terimakasih 🙏🏻

  // Kontak Kami:
  // Layanan Informasi/Humas : 082131914411
  // Telp Undiksha : (0362) 22570
  // Layanan Teknis UPA TIK : 085934888827
  // Layanan Informasi Publik : https://go.undiksha.ac.id/info`);

  //               const url = `https://wa.me/${phone}?text=${message}`;
  //               window.open(url, "_blank");
  //             }}
  //             className="cursor-pointer"
  //           >
  //             <img
  //               src="https://static.cdnlogo.com/logos/w/43/whatsapp.svg"
  //               alt="Whatsapp"
  //               width={30}
  //               height={30}
  //               className="mx-auto"
  //             />
  //           </Button>
  //         </div>
  //       );
  //     },
  //   },
  // {
  //   accessorKey: "tahun",
  //   header: ({ column }) => {
  //     return (
  //       <Button
  //         variant="ghost"
  //         onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
  //       >
  //         Tahun
  //         <ArrowUpDown className="w-4 h-4 ml-2" />
  //       </Button>
  //     )
  //   },
  //   cell: ({ row }) => {
  //     return <div className="text-center">{row.getValue("tahun")}</div>
  //   },
  // },
  {
    accessorKey: "periode.jalur_jenis.nama_jalur_jenis",
    header: ({ column }) => {
      return (
        <Button
          variant="ghost"
          onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
        >
          Jalur
          <ArrowUpDown className="w-4 h-4 ml-2" />
        </Button>
      );
    },
  },
  {
    accessorKey: "nomor_pendaftaran",
    header: ({ column }) => {
      return (
        <Button
          variant="ghost"
          onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
        >
          Nomor Pendaftaran
          <ArrowUpDown className="w-4 h-4 ml-2" />
        </Button>
      );
    },
  },
  {
    accessorKey: "data_siswa.nama_lengkap",
    header: ({ column }) => {
      return (
        <Button
          variant="ghost"
          onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
        >
          Nama Lengkap
          <ArrowUpDown className="w-4 h-4 ml-2" />
        </Button>
      );
    },
  },
  {
    accessorKey: "data_siswa.email",
    header: ({ column }) => {
      return (
        <Button
          variant="ghost"
          onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
        >
          Email
          <ArrowUpDown className="w-4 h-4 ml-2" />
        </Button>
      );
    },
  },
  // {
  //   accessorKey: "data_siswa.handphone",
  //   header: ({ column }) => {
  //     return (
  //       <Button
  //         variant="ghost"
  //         onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
  //       >
  //         Nomor Handphone
  //         <ArrowUpDown className="w-4 h-4 ml-2" />
  //       </Button>
  //     )
  //   },
  // },
  // {
  //   accessorKey: "is_valid_pendaftaran",
  //   header: ({ column }) => {
  //     return (
  //       <Button
  //         variant="ghost"
  //         onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
  //       >
  //         Status Validasi Pendaftaran
  //         <ArrowUpDown className="w-4 h-4 ml-2" />
  //       </Button>
  //     )
  //   },
  //   cell: ({ row }) => {
  //     return (
  //       <div>
  //         {!row.getValue("is_valid_pendaftaran") ||
  //         row.getValue("is_valid_pendaftaran") == 0 ? (
  //           <Badge variant={"secondary"}>Belum Divalidasi</Badge>
  //         ) : (
  //           <Badge>Sudah Divalidasi</Badge>
  //         )}
  //       </div>
  //     )
  //   },
  // },
  // {
  //   accessorKey: "is_valid_isi_ukt",
  //   header: ({ column }) => {
  //     return (
  //       <Button
  //         variant="ghost"
  //         onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
  //       >
  //         Status Validasi Data Penunjang UKT
  //         <ArrowUpDown className="w-4 h-4 ml-2" />
  //       </Button>
  //     )
  //   },
  //   cell: ({ row }) => {
  //     return (
  //       <div>
  //         {!row.getValue("is_valid_isi_ukt") ||
  //         row.getValue("is_valid_isi_ukt") == 0 ? (
  //           <Badge variant={"secondary"}>Belum Divalidasi</Badge>
  //         ) : (
  //           <Badge>Sudah Divalidasi</Badge>
  //         )}
  //       </div>
  //     )
  //   },
  // },
  {
    accessorKey: "is_lulus",
    header: ({ column }) => {
      return (
        <Button
          variant="ghost"
          onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
        >
          Status Kelulusan
          <ArrowUpDown className="w-4 h-4 ml-2" />
        </Button>
      );
    },
    cell: ({ row }) => {
      return (
        <div>
          {row.getValue("is_lulus") === 0 ? (
            <Badge variant={"secondary"}>Belum Lulus</Badge>
          ) : (
            <Badge variant={"success"}>Lulus</Badge>
          )}
        </div>
      );
    },
  },
  // {
  //   accessorKey: "is_daftar_kembali",
  //   header: ({ column }) => {
  //     return (
  //       <Button
  //         variant="ghost"
  //         onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
  //       >
  //         Status Daftarkembali
  //         <ArrowUpDown className="w-4 h-4 ml-2" />
  //       </Button>
  //     )
  //   },
  //   cell: ({ row }) => {
  //     return (
  //       <div>
  //         {row.getValue("is_daftar_kembali") == 0 ? (
  //           <Badge variant={"secondary"}>Belum Daftarkembali</Badge>
  //         ) : (
  //           <Badge>Sudah Daftarkembali</Badge>
  //         )}
  //       </div>
  //     )
  //   },
  // },
  // {
  //   accessorKey: "data_tagihan_pendaftaran",
  //   header: ({ column }) => {
  //     return (
  //       <Button
  //         variant="ghost"
  //         onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
  //       >
  //         Pembayaran Pendaftaran
  //         <ArrowUpDown className="w-4 h-4 ml-2" />
  //       </Button>
  //     )
  //   },
  //   cell: ({ row }) => {
  //     return (
  //       <div className="flex flex-col gap-y-3">
  //         {row.original?.data_tagihan_pendaftaran &&
  //           row.original?.data_tagihan_pendaftaran?.map(
  //             (tagihan: DataTagihanDaftarPlaza) => {
  //               return (
  //                 <div
  //                   key={tagihan.id_data_tagihan_daftar_plaza}
  //                   className="flex flex-col"
  //                 >
  //                   {tagihan.nomor_tagihan}
  //                   <div className="w-fit">
  //                     {tagihan.status_bayar == 1 ? (
  //                       <Badge variant={"secondary"}>Aktif/Belum dibayar</Badge>
  //                     ) : tagihan.status_bayar == 2 ? (
  //                       <Badge variant={"success"}>Sudah dibayar</Badge>
  //                     ) : tagihan.status_bayar == 3 ? (
  //                       <Badge variant={"destructive"}>Expired</Badge>
  //                     ) : (
  //                       ""
  //                     )}
  //                   </div>
  //                 </div>
  //               )
  //             }
  //           )}
  //       </div>
  //     )
  //   },
  // },
  // {
  //   accessorKey: "data_tagihan_pendaftaran.amount",
  //   header: ({ column }) => {
  //     return (
  //       <Button
  //         variant="ghost"
  //         onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
  //       >
  //         Nominal Pembayaran Pendaftaran
  //         <ArrowUpDown className="w-4 h-4 ml-2" />
  //       </Button>
  //     )
  //   },
  //   cell: ({ row }) => {
  //     return (
  //       <div className="flex flex-col gap-y-3">
  //         {row.original?.data_tagihan_pendaftaran &&
  //           row.original?.data_tagihan_pendaftaran?.map(
  //             (tagihan: DataTagihanDaftarPlaza) => {
  //               return (
  //                 <div key={tagihan.id_data_tagihan_daftar_plaza}>
  //                   {tagihan.amount && formatRupiah(Number(tagihan.amount))}
  //                 </div>
  //               )
  //             }
  //           )}
  //       </div>
  //     )
  //   },
  // },
  // {
  //   accessorKey: "data_penetapan_ukt.ref_nominal_ukt.jenis_ukt",
  //   header: ({ column }) => {
  //     return (
  //       <Button
  //         variant="ghost"
  //         onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
  //       >
  //         Jenis UKT
  //         <ArrowUpDown className="w-4 h-4 ml-2" />
  //       </Button>
  //     )
  //   },
  //   cell: ({ row }) => {
  //     const jenisUkt =
  //       row.original?.data_penetapan_ukt?.ref_nominal_ukt?.jenis_ukt
  //         ?.nama_jenis_ukt
  //     return <div>{jenisUkt}</div>
  //   },
  // },
  // {
  //   accessorKey: "data_penetapan_ukt.nominal_ukt",
  //   header: ({ column }) => {
  //     return (
  //       <Button
  //         variant="ghost"
  //         onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
  //       >
  //         Nominal UKT
  //         <ArrowUpDown className="w-4 h-4 ml-2" />
  //       </Button>
  //     )
  //   },
  //   cell: ({ row }) => {
  //     const nominalUkt =
  //       row.original?.data_penetapan_ukt?.ref_nominal_ukt?.nominal_ukt
  //     return <div>{nominalUkt ? formatRupiah(Number(nominalUkt)) : ""}</div>
  //   },
  // },
  // {
  //   accessorKey: "nim",
  //   header: ({ column }) => {
  //     return (
  //       <Button
  //         variant="ghost"
  //         onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
  //       >
  //         NIM
  //         <ArrowUpDown className="w-4 h-4 ml-2" />
  //       </Button>
  //     )
  //   },
  // },
];
